module.exports = __webpack_public_path__ + "img/michaely-pro.b36b67e2.jpg";